import React from "react";

abstract class AbstractDataComponent<P> extends React.PureComponent<P, never> {
    // @ts-ignore
    public state: never;
    // @ts-ignore
    public setState: never;

    public render() {
        return null;
    }
}

export default AbstractDataComponent;
